import { Component, OnInit } from '@angular/core';
import { CallTraceService } from '../../services/call-trace.service';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {AuthService} from '../../../../../core/service/auth.service';

import * as _ from 'underscore';
import {MessagingService} from '../../../../../core/service/messaging.service';
import {VnaPortalSelected} from '../../../../../core/data/messaging/VnaPortalSelected';
import {DatesParserService} from '../../../../../core/service/dates_parser.service';

@Component({
  selector: 'app-call-trace',
  templateUrl: './call-trace.component.html',
  styleUrls: ['./call-trace.component.scss']
})
export class CallTraceComponent implements OnInit {

    private formData: FormGroup;
    enabled: boolean = false;
    error: string = '';

    result: Object = {};
    submitted: boolean = false;

    constructor(private callTraceService: CallTraceService, private fb: FormBuilder, private auth: AuthService, private messaging: MessagingService, private datesParser: DatesParserService) {

        this.formData = this.fb.group({
            'element': new FormControl('', Validators.required),
            'service' : new FormControl('', Validators.required),
            'date' : new FormControl()
        });
    }

    traceElement(): void {

        this.error = '';
        this.result = {};
        if(!this.formData.valid){
            this.submitted = true;
            return;
        }

        this.enabled = true;
        const query = this.datesParser.cleanDates(this.formData.value, ['date'], false);
        this
            .callTraceService
            .traceCall(this.auth.getPkPortal(), query['service'], {'portal' : this.auth.getPortalSelected().portal, 'element' : query['element'], 'date' : query['date']})
            .subscribe(
                (result) => {
                    if(result.hasOwnProperty('error')){
                        this.error = result['error'];
                    }
                    else{
                        this.result = result;
                        this.result['price'] = this.result['price'] + '/second -- (' + this.result['price'] * 60 + '/min)';
                    }

                    this.enabled = false;
                }
            )
        ;
    }

    isEmptyResult(): boolean {
        return _.isEmpty(this.result);
    }

    ngOnInit() {
        this.messaging.message.subscribe(
            (value) => {
                if(value instanceof VnaPortalSelected && !value.isTheFirst()){
                    this.result = {};
                    this.formData.controls['element'].setValue('');
                    this.submitted = false;
                }
            }
        )
    }

}



// WEBPACK FOOTER //
// /var/www/backend/src/app/phone/tools/trace/components/call-trace/call-trace.component.ts